export enum TipoAlteracaoPessoalEnum {
  Email = 1,
  Senha,
  Telefone
}
